import { render, staticRenderFns } from "./create_event_dialog.vue?vue&type=template&id=86f53670&scoped=true"
import script from "./create_event_dialog.vue?vue&type=script&lang=js"
export * from "./create_event_dialog.vue?vue&type=script&lang=js"
import style0 from "./create_event_dialog.vue?vue&type=style&index=0&id=86f53670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f53670",
  null
  
)

export default component.exports